import { render, staticRenderFns } from "./agendaList.vue?vue&type=template&id=4a2b8e73&scoped=true&"
import script from "./agendaList.vue?vue&type=script&lang=js&"
export * from "./agendaList.vue?vue&type=script&lang=js&"
import style0 from "./agendaList.vue?vue&type=style&index=0&id=4a2b8e73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2b8e73",
  null
  
)

export default component.exports